// Sadržaj sajta je HTML sa servera; skripta dodaje filtere, detalj teme, korpu (teme i proizvodi) i njen spisak na
// stranici porudžbine, ponudu po delatnosti, zatvaranje menija, izabranu kategoriju na telefonu, uvećanje slika proizvoda
// i izbor boje i slike u galeriji. Bez JavaScript-a te kontrole ostaju skrivene, a sve ostalo radi.
import { enhanceCart } from './lib/cart';
import { enhanceCatalog } from './lib/catalog';
import { enhanceCategoryTiles } from './lib/category-tiles';
import { enhanceGallery } from './lib/gallery';
import { enhanceLightbox } from './lib/lightbox';
import { enhanceMenu } from './lib/menu';
import { enhanceNiches } from './lib/niches';
import { clearOrderedCart, enhanceOrderForm, enhanceOrderReview } from './lib/order';
import { enhanceProductOrder } from './lib/product-order';
import { enhanceSwatchStrip } from './lib/swatch-strip';
import { enhanceThemeDetail } from './lib/theme-detail';
import { createToast } from './lib/toast';

$(() => {
  enhanceMenu();
  enhanceCategoryTiles();
  const cart = enhanceCart(createToast());
  const detail = enhanceThemeDetail(cart);
  if (detail) enhanceCatalog(detail);
  enhanceProductOrder(cart);
  enhanceOrderForm(cart);
  enhanceOrderReview(cart);
  clearOrderedCart(cart);
  enhanceNiches();
  enhanceGallery();
  enhanceSwatchStrip();
  enhanceLightbox();
});
